module.exports = __webpack_public_path__ + "img/help17_repeats_table.6adcfe14.png";